export default "__VITE_ASSET__nfLsnNcy__"